import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardHeader,
  CardContent,
  Stack,
  Button,
  Box,
  Divider,
  Avatar,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import ApiService from "../../services/categoryManagementApi";

const { categoryManagementApi } = ApiService;

const CategoryView = () => {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await categoryManagementApi.getById({ id: id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  return (
    <Box>
      <Helmet>
        <title>Category Management</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="Category View" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Box display="flex" justifyContent="center" mb={2}>
                    <Avatar
                      src={IMAGE_BASE + data?.image}
                      alt="Profile Icon"
                      sx={{ width: 100, height: 100 }}
                    />
                  </Box>

                  <Stack spacing={2}>
                    <Typography variant="h6">Name (English)</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.name || ""}
                    </Typography>
                    <Divider></Divider>

                     <Typography variant="h6">Name (Khmer)</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.nameKh || ""}
                    </Typography>
                    <Divider></Divider>

                     <Typography variant="h6">Category Position</Typography>
                    <Typography
                      variant="body1"
                      sx={{ overflowWrap: "break-word" }}
                    >
                      {data?.index || ""}
                    </Typography>
                    <Divider></Divider>

                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default CategoryView;
